// extracted by mini-css-extract-plugin
export default {"title":"quick-charge-method-modal_title__G-wJP","options":"quick-charge-method-modal_options__ygPz7","option":"quick-charge-method-modal_option__SZm3k"};